import { julo } from '@julo-ui/react';
import { articleCx } from './styles';

const TncContent = () => {
  return (
    <julo.article className={articleCx}>
      <p>
        <b>Terakhir Diubah: 25 Oktober 2025</b>
      </p>
      <p style={{ textAlign: 'center' }}>
        <b>SYARAT DAN KETENTUAN UMUM </b>
      </p>
      <p>Salam dari JULO!</p>
      <p>
        Terima kasih kepercayaan Anda telah memilih JULO sebagai Penyedia
        Layanan Jasa Keuangan Anda. Syarat dan Ketentuan Umum ini dan
        (Adendum)-Adendumnya (“Syarat dan Ketentuan Umum”) adalah ketentuan
        antara pengguna layanan JULO (“Anda”) dan PT. Julo Teknologi Perdana,
        masing-masing induk dan anak perusahaan, Afiliasi, perusahaan terkait
        dan entitas yang dikendalikan bersama (secara bersama-sama disebut
        “JULO”, “kami”, atau “milik kami”) yang mengatur bagaimana Anda
        mengakses dan menggunakan layanan yang disediakan oleh JULO dan/atau
        afiliasi JULO melalui penggunaan aplikasi seluler dan situs web JULO
        (masing-masing disebut “Aplikasi” dan “Situs Web”), serta produk, fitur,
        dan layanan lainnya secara global, yang dioperasikan oleh JULO (secara
        bersama-sama disebut “Layanan”).
      </p>
      <p>
        Berikut selengkapnya Syarat dan Ketentuan Umum yang dapat Anda baca:
      </p>
      <ol>
        <li>
          <b>
            Istilah Penting Apa saja yang Anda Harus Ketahui pada Syarat dan
            Ketentuan Umum ini?
          </b>
        </li>
        <ol style={{ listStyle: 'lower-alpha' }}>
          <li>
            <b>Afiliasi</b> berarti hubungan antara perusahaan dengan pihak yang
            secara langsung atau tidak langsung mengendalikan, dikendalikan,
            atau di bawah satu pengendalian dari perusahaan tersebut.
          </li>
          <li>
            <b>Akun</b> berarti data tentang Pengguna, minimum terdiri dari
            username, password, dan nomor telepon yang wajib diisi oleh Pengguna
            Terdaftar.
          </li>
          <li>
            <b>Anda</b> berarti memiliki arti sebagaimana yang dijelaskan diatas
            atau pada bagian awal Syarat dan Ketentuan Umum ini.
          </li>
          <li>
            <b>Aplikasi</b> berarti memiliki arti sebagaimana yang dijelaskan
            diatas atau pada bagian awal Syarat dan Ketentuan Umum ini.
          </li>
          <li>
            <b>Hak Kekayaan Intelektual</b> berarti hak-hak secara hukum yang
            berhubungan dengan hasil penemuan dan kreativitas yang dimiliki
            dalam hal ini adalah JULO, yang karenanya memiliki perlindungan
            secara hukum dari Pemerintah.
          </li>
          <li>
            <b>Konten</b> atau Konten Anda adalah data pribadi, segala materi
            dan informasi yang Anda berikan, unggah, publikasikan, sediakan,
            kirimkan dan tampilkan pada Sistem Elektronik JULO.
          </li>
          <li>
            <b>JULO</b> adalah memiliki arti sebagaimana yang dijelaskan diatas
            atau pada bagian awal Syarat dan Ketentuan Umum ini.
          </li>
          <li>
            <b>Layanan</b> adalah memiliki arti sebagaimana yang dijelaskan
            diatas atau pada bagian awal Syarat dan Ketentuan Umum ini.
          </li>
          <li>
            <b>Mitra Bisnis</b> atau <b>Mitra Bisnis JULO</b> adalah pihak
            ketiga yang bekerjasama dengan JULO dengan pola
            <i>partnership</i>/kemitraan untuk menunjang bisnis JULO.
          </li>
          <li>
            <b>Pengguna</b> berarti pihak (terdaftar/tidak terdaftar), termasuk
            namun tidak terbatas pada Anda yang berarti nasabah, customer,
            pelanggan, pemilik kartu, pemberi pinjaman/pemberi dana, penerima
            pinjaman/penerima dana, pihak ketiga lainnya, mitra, user{' '}
            <i>offline</i>
            (apabila ada), klien, dan penyebutan apapun lainnya yang menunjukan
            pihak yang telah mengakses dan menggunakan Aplikasi dan/atau Situs
            Web, yang mana wajib mematuhi Syarat dan Ketentuan Umum ini beserta
            ketentuan-ketentuan lain termasuk namun tidak terbatas pada
            Kebijakan Privasi JULO.
          </li>
          <li>
            <b>Sistem Elektronik</b> berarti serangkaian perangkat dan prosedur
            elektronik yang berfungsi mempersiapkan, mengumpulkan, mengolah,
            menganalisis, menyimpan, menampilkan, mengumumkan, mengirimkan,
            dan/atau menyebarkan Informasi Elektronik.
          </li>
          <li>
            <b>Situs Web</b> berarti memiliki arti sebagaimana yang dijelaskan
            diatas atau pada bagian awal Syarat dan Ketentuan Umum ini.
          </li>
          <li>
            <b>Syarat dan Ketentuan Penggunaan</b> berarti aturan yang
            menjelaskan fitur utama dari JULO, yang berisi spesifikasi Layanan
            beserta segala fitur-fitur tambahan yang tersimpan didalamnya baik
            yang dimiliki sendiri maupun dimiliki atas kerjasama dengan pihak
            lain.
          </li>
          <li>
            <b>Syarat dan Ketentuan Fitur/Program</b> berarti bagian dari Syarat
            dan Ketentuan Penggunaan yang menjelaskan spesifikasi atas fitur
            tambahan yang berfungsi mengembangkan dan mendukung kegiatan usaha
            JULO.
          </li>
          <li>
            <b>Kebijakan Privasi</b> adalah ketentuan lebih lanjut mengenai
            tujuan dan pemrosesan data pribadi yang merujuk kepada{' '}
            <a
              href='https://www.julo.co.id/privacy-policy'
              target='_blank'
              rel='noreferrer noopener'
            >
              https://www.julo.co.id/privacy-policy
            </a>
          </li>
        </ol>
        <li>
          <b>Bagaimana Cara Mengakses dan Menggunakan Akun JULO?</b>
          <ol style={{ listStyle: 'lower-alpha' }}>
            <li>
              Sebelum menggunakan Aplikasi, Anda harus menyetujui Ketentuan
              Penggunaan ini dan Kebijakan Privasi, dan mendaftarkan diri Anda
              dengan memberikan informasi yang dibutuhkan oleh Kami.
            </li>
            <li>
              Saat melakukan pendaftaran, Kami akan meminta Anda untuk
              memberikan nomor telepon seluler pribadi Anda yang sah. Anda dapat
              mengubah informasi data diri Anda pada fitur pengaturan dalam
              Aplikasi.
            </li>
            <li>
              Sistem Kami akan mengirimkan kode verifikasi secara otomatis
              melalui pesan singkat ke nomor telepon genggam yang Anda berikan.
              Anda perlu melakukan verifikasi dengan memasukan kode verifikasi
              tersebut pada halaman pendaftaran di Aplikasi.
            </li>
            <li>
              Kode verifikasi (<i>one time password</i>) dihasilkan secara
              otomatis otomatis oleh sistem kami. kami tidak mengetahui dan
              tidak pernah meminta kode verifikasi Anda. Anda dilarang
              memberitahukan kode verifikasi anda kepada siapapun bahkan kepada
              kami atau pihak lain yang mengaku sebagai perwakilan kami. Apabila
              hal ini terjadi maka Anda sadar bahwa hal ini bukan merupakan
              tanggung jawab Kami.
            </li>
            <li>
              Dengan mengakses dengan mengunduh dan menggunakan Layanan JULO,
              Anda menyatakan dan mengakui bahwa:
              <ol style={{ listStyle: 'lower-roman' }}>
                <li>
                  Anda telah membaca, memahami dan menyetujui semua yang tertera
                  dalam Syarat dan Ketentuan Umum ini.
                </li>
                <li>
                  Anda adalah pengguna Layanan JULO yang berusia minimal 18
                  tahun.
                </li>
                <li>
                  Anda dalam keadaan sadar dan tidak di bawah pengaruh pihak
                  lain serta tidak melakukan atau memiliki catatan yang tidak
                  baik baik dari Kepolisian Republik Indonesia ataupun dari
                  Kepolisian atau satuan keamanan yang terkait di negara manapun
                  mengenai tindakan-tindakan/perbuatan-perbuatan ilegal yang
                  dapat merugikan JULO ataupun pihak lainnya baik yang
                  menggunakan layanan Kami ataupun tidak, melakukan pendanaan
                  yang bersumber dari/atau sengaja menggunakan Layanan JULO
                  untuk, termasuk namun tidak terbatas melakukan tindakan
                  pencucian uang, pendanaan terorisme, pendanaan pembelian
                  senjata massal, perdagangan narkotik dan obat-obat terlarang,
                  perjudian, mengunggah, mentransmisikan, mengirim email atau
                  mempublikasikan informasi atau materi apa pun yang berbahaya,
                  bersifat mengancam, kasar, memfitnah, tidak pantas, menghina
                  (dalam bentuk apa pun), merupakan pencemaran nama baik atau
                  fitnah, diskriminatif, tidak dapat diterima secara rasial atau
                  etnis atau mengandung pornografi.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk memanfaatkan Layanan JULO untuk
                  keperluan-keperluan yang bertentangan dengan Hukum.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk menggunakan, mengakses,
                  mengumpulkan dan/atau mengambil data pada Sistem Elektronik
                  JULO.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk menggunakan sarana dan/atau
                  program otomatis apapun untuk mengakses Sistem Elektronik JULO
                  dan/atau mengumpulkan informasi dari Sistem Elektronik JULO.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk mengunggah, mempublikasikan,
                  mengirim email dan menyediakan iklan, promosi, junk mail, spam
                  dan/atau segala bentuk apapun lainnya baik untuk komersial
                  ataupun non-komersial, pada Sistem Elektronik JULO dan/atau
                  pihak manapun.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk mengubah tampilan pada Sistem
                  Elektronik JULO.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk membuat pop-up untuk setiap
                  akses terhadap Sistem Elektronik JULO.
                </li>
                <li>
                  Anda tidak diperbolehkan untuk melakukan hal-hal lain yang
                  dapat merugikan JULO dan/atau fasilitas dalam Sistem
                  Elektronik JULO.
                </li>
                <li>
                  Anda sepakat bahwa apabila terdapat pelanggaran yang Anda
                  lakukan atas Syarat dan Ketentuan Umum ini, atau terhadap
                  Hukum yang berlaku, maka JULO dapat menghapus akun Anda pada
                  Sistem Elektronik JULO secara sepihak dan tanpa pemberitahuan,
                  serta membatasi atau melarang Anda menggunakan Sistem
                  Elektronik JULO dan mengakhiri Layanan kepada Anda. Anda
                  sepakat bahwa segala kerugian materiil maupun non-materiil
                  yang timbul dari penghapusan akun dan/atau pembatasan akses
                  Anda sebagaimana dimaksud diatas merupakan sepenuhnya tanggung
                  jawab Anda.
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <b>
            Apa yang Perlu Anda Pahami mengenai Hak Kekayaan Intelektual Kami?
          </b>
          <ol>
            <li>
              Hak kekayaan intelektual dalam situs dan Sistem Elektronik JULO
              seluruhnya merupakan kepemilikan JULO. Hak kekayaan intelektual
              ini meliputi hak cipta, hak basis, paten, merek dagang, desain
              terdaftar dan juga semua hak cipta yang terdapat pada konten
              Sistem Elektronik JULO.
            </li>
            <li>
              Merek dagang JULO (baik terdaftar ataupun tidak), gambar grafis,
              logo, desain, header, halaman, ikon, tulisan dan nama layanan
              milik JULO yang ditampilkan pada Sistem Elektronik JULO adalah
              aset milik JULO yang secara tegas dilindungi oleh JULO.
            </li>
            <li>
              Semua produk, data, asumsi, model, model statistik, formula,
              <i>angka/ranking/score</i>, <i>machine learning</i> dan semua
              pembelajaran sebagai hasil dari proses uji kelayakan{' '}
              <i>underwriting</i> secara saintifik, seluruh statistik dan
              teknologinya, merupakan aset milik JULO yang secara tegas
              dilindungi oleh JULO.
            </li>
            <li>
              Akses pada konten Sistem Elektronik dan Layanan JULO tidak
              dianggap sebagai pemberian, sehingga apabila menginginkan
              pengerjaan/pengembangan/penggunaan konten tersebut, diharuskan
              untuk meminta persetujuan tertulis terlebih dahulu dari JULO.
            </li>
            <li>
              Penggunaan nama dan merek dagang JULO, termasuk dalam iklan,
              publisitas atau sebagai hyperlink, harus dengan persetujuan
              tertulis terlebih dahulu dari JULO dan/atau pihak ketiga yang
              relevan. Segala hal yang berhubungan dengan JULO merupakan aset
              milik JULO yang secara tegas dilindungi oleh JULO.
            </li>
            <li>
              Nama domain untuk situs JULO merupakan hak milik JULO dan
              pengadopsian dan/atau penggunaan kembali nama domain tersebut sama
              sekali tidak diizinkan.
            </li>
            <li>
              Akses serta penggunaan Sistem Elektronik JULO untuk mengunduh
              dan/atau mencetak salinan dari bagian manapun dari Sistem
              Elektronik JULO untuk penggunaan pribadi, diperbolehkan selama
              tidak melanggar hak kekayaan intelektual milik JULO. Anda wajib
              memelihara semua hak cipta atau memberitahukan kepemilikan dari
              salinan dan/atau unduhan tersebut. Status JULO sebagai penulis
              konten pada Sistem Elektronik JULO harus selalu diakui.
            </li>
            <li>
              Lisensi terbatas saat mengakses Sistem Elektronik JULO ini
              sewaktu-waktu dapat dibatalkan tanpa pemberitahuan atau alasan.
              Penggunaan Sistem Elektronik tanpa izin tertulis dari JULO
              dan/atau pihak ketiga yang relevan, sangat dilarang dan lisensi
              yang diberikan dalam Syarat dan Ketentuan Umum harus diakhiri.
              Penggunaan tidak sah tersebut melanggar Hukum yang berlaku,
              termasuk undang-undang hak cipta dan merek, peraturan dan
              undang-undang komunikasi yang berlaku, yang dapat dituntut secara
              hukum kepada Anda.
            </li>
            <li>
              Penggunaan merek, Sistem Elektronik dan Layanan JULO yang
              melanggar Syarat dan Ketentuan Umum, akan dikenakan sanksi berupa
              pemberhentian penggunaan. Anda berkewajiban untuk mengembalikan
              dan/atau memusnahkan materi yang telah Anda salin.
            </li>
          </ol>
        </li>
        <li>
          <b>Pilihan Hukum dan Pilihan Forum</b>
          <ol>
            <li>
              Syarat dan Ketentuan Umum dan ketentuan lain yang ditetapkan oleh
              JULO, diatur oleh dan ditafsirkan sesuai dengan hukum Republik
              Indonesia.
            </li>
            <li>
              Anda sepakat bahwa tindakan hukum apapun dan/atau sengketa yang
              mungkin timbul dari, berhubungan dengan, termasuk namun tidak
              terbatas atas penggunaan Sistem Elektronik JULO, dokumentasi
              elektronik berkaitan dengan Anda sebagai pengguna layanan JULO,
              akan tunduk pada yurisdiksi Lembaga Alternatif Penyelesaian
              Sengketa Sektor Jasa Keuangan (“<b>LAPS SJK</b>”) dan diselesaikan
              secara non-eksklusif, baik dalam yurisdiksi Pengadilan Negeri
              Jakarta Selatan Republik Indonesia atau pengadilan manapun di
              setiap yurisdiksi yang kompeten.
            </li>
          </ol>
        </li>
        <li>
          <b>Mengenai Kelebihan Pembayaran</b>
          <ol style={{ listStyle: 'lower-alpha' }}>
            Jika Anda melakukan pembayaran melebihi jumlah tagihan, terdapat 2
            (dua) skema pengembalian kelebihan pembayaran yang dapat dilakukan:
            <ol style={{ listStyle: 'lower-roman' }}>
              <li>
                Jika jumlah kelebihan bayar senilai Rp20.000 (dua puluh ribu
                rupiah) atau lebih, dana kelebihan bayar tersebut akan
                ditransfer kembali ke rekening asal paling lambat 10 (sepuluh)
                hari. Jika Anda ingin proses pengembalian kelebihan dana bayar
                lebih cepat waktu yang ditentukan, Anda dapat tunjukkan bukti
                kelebihan bayar dalam bentuk mutasi rekening atau bukti transfer
                di aplikasi JULO atau kepada agen kami melalui fitur Live Chat.
              </li>
              <li>
                Jika jumlah kelebihan bayar kurang dari Rp20.000 (dua puluh ribu
                rupiah), dana akan otomatis dimasukkan ke dalam <i>cashback</i>{' '}
                di JULO.
              </li>
            </ol>
            <li>
              Pengembalian kelebihan dana bayar akan dikenakan biaya admin
              tertentu (sesuai dengan bank terkait).
            </li>
            <li>
              Kebijakan terkait Kelebihan Pembayaran dapat berbeda tergantung
              pada jenis produk pinjaman yang Anda pilih.
            </li>
          </ol>
        </li>
        <li>
          <b>Kebijakan Privasi</b>
          <p>
            Informasi terkait jenis data pribadi yang kami kumpulkan, proses,
            dan gunakan, serta tujuan pemrosesannya, diatur lebih lanjut dalam
            Kebijakan Privasi yang dapat diakses melalui{' '}
            <a
              href='https://www.julo.co.id/privacy-policy'
              target='_blank'
              rel='noreferrer noopener'
            >
              https://www.julo.co.id/privacy-policy.
            </a>
          </p>
        </li>
        <li>
          <b>Hal-Hal Lain yang Perlu Diatur</b>
          <ol>
            <li>
              Anda mengerti dan setuju bahwa Ketentuan Penggunaan ini merupakan
              perjanjian dalam bentuk elektronik dan tindakan Anda menekan
              tombol ‘daftar’ saat pembukaan Akun atau tombol ‘masuk’ saat akan
              mengakses Akun Anda merupakan persetujuan aktif Anda untuk
              mengikatkan diri dalam perjanjian dengan Kami sehingga keberlakuan
              Ketentuan Penggunaan ini dan Kebijakan Privasi adalah sah dan
              mengikat secara hukum dan terus berlaku sepanjang penggunaan
              Aplikasi dan Layanan oleh Anda.
            </li>
            <li>
              Anda tidak akan mengajukan tuntutan atau keberatan apapun terhadap
              keabsahan dari Syarat dan Ketentuan Umum ini atau Kebijakan
              Privasi yang dibuat dalam bentuk elektronik.
            </li>
            <li>
              Anda tidak dapat mengalihkan hak Anda berdasarkan Ketentuan
              Penggunaan ini tanpa persetujuan tertulis sebelumnya dari Kami.
              Namun, Kami dapat mengalihkan hak Kami berdasarkan Ketentuan
              Penggunaan ini setiap saat kepada pihak lain tanpa perlu
              mendapatkan persetujuan terlebih dahulu dari atau memberikan
              pemberitahuan sebelumnya kepada Anda.
            </li>
            <li>
              Jika salah satu dari ketentuan dalam Ketentuan Penggunaan ini
              tidak dapat diberlakukan, hal tersebut tidak akan memengaruhi
              ketentuan lainnya.
            </li>
            <li>
              Kami membuat Ketentuan Penggunaan ini dalam bahasa Indonesia dan
              Inggris. Setiap perbedaan akan diartikan sesuai dengan bahasa
              Indonesia.
            </li>
          </ol>
        </li>
        <li>
          <b>Kontak Kami</b>
          <p>
            Untuk informasi lebih lanjut, hubungi JULO melalui email:
            <a href='mailto:cs@julo.co.id.'>cs@julo.co.id.</a>
          </p>
        </li>
      </ol>
    </julo.article>
  );
};

export default TncContent;
